import { cleanEmbedListParams } from '../../embedForms/embedList/embedListUtils';

export { patchEmbedListRowActive } from '../../embedForms/embedList/embedListUtils';

export const QUICK_REPLIES_ADVANCED_FILTER_OPTIONS = {
    created_at: { label: 'Created date', visible: false, default: '' },
    created_at_range: { label: 'Created range', visible: false, default: [] },
};

export const buildQuickRepliesApiParams = (filters, sort, pagination = {}) => {
    const params = {
        sort_by: sort.by,
        sort_direction: sort.direction,
    };

    if (pagination.page) {
        params.page = pagination.page;
    }
    if (pagination.perPage) {
        params.per_page = pagination.perPage;
    }

    if (filters.text?.trim()) {
        params.text = filters.text.trim();
    }
    if (Array.isArray(filters.created_by) && filters.created_by.length > 0) {
        params.created_by = filters.created_by.join(',');
    }
    if (Array.isArray(filters.is_active) && filters.is_active.length > 0) {
        params.is_active = filters.is_active
            .map((v) => (v === true || v === 1 || v === '1' ? '1' : '0'))
            .join(',');
    }
    if (filters.created_at) {
        params.created_at = filters.created_at;
    }
    if (filters.created_at === 'range' && Array.isArray(filters.created_at_range)) {
        params.created_at_range = filters.created_at_range.join(',');
    }

    return cleanEmbedListParams(params);
};

export const buildCreatorQuickFilterOptions = (users = []) =>
    users.map((user) => ({
        value: user.id,
        label: user.name,
    }));
